export default __webpack_public_path__ + "static/service4-9ad5a8d87ccfd77abc79a963e9705e26.png";